import { render, staticRenderFns } from "./ViewSingleCompany.vue?vue&type=template&id=11ffc037"
import script from "./ViewSingleCompany.vue?vue&type=script&lang=js"
export * from "./ViewSingleCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports